import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UiIconModel } from '@local/ui-infra';
import { HighlightStyle } from '@shared/pipes';
import { LogService } from '@shared/services';
import { stopEvent } from '@shared/utils/elements-util';
import { getIconModel } from '@shared/utils/set-icon.util';
import { Result } from '@unleash-tech/apps-client-sdk';
import { Logger } from '@unleash-tech/js-logger';
import { HubService } from 'src/app/bar/services/hub.service';
import { InvokeCommand } from '../../models/invoke-command.model';
import { isAttachment } from '../../utils/results.util';

@Component({
  selector: 'result-sub-view',
  templateUrl: './result-sub-view.component.html',
  styleUrls: ['./result-sub-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultSubViewComponent implements OnInit {
  readonly MAX_HEIGHT_SNIPPET = 70;
  private _model: Result.View;
  private logger: Logger;
  highlightStyle: HighlightStyle = 'default';

  @Input() set model(val: Result.View) {
    this._model = val;
  }
  @Input() highlights: Array<string>;
  @Output() invoke = new EventEmitter<InvokeCommand>();

  get model() {
    return this._model;
  }

  get iconProfile(): UiIconModel {
    return getIconModel(this.model?.icon);
  }

  constructor(private logService: LogService, private hubService: HubService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.logger = this.logService.scope('ResultSubView');
  }

  @ViewChild('snippet', { read: ElementRef }) snippetRef: ElementRef;

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    stopEvent(event);
    if (this.model?.title?.onClick) {
      this.sendCommand({ command: this.model.title.onClick, trigger: 'mouse_click' });
    }
  }

  isAttachment(item: any): boolean {
    return isAttachment(item);
  }

  private sendCommand(invokeCommand: InvokeCommand) {
    if (!invokeCommand) return;
    this.invoke.emit(invokeCommand);
  }
}
